import React from 'react';
import SavingAddressSearch from '../../AddressSearch/AddressSearch/SavingAddressSearch';
import BurgerMenu from '../BurgerMenu/BurgerMenu';

const AddressSearchAndBurgerMenu = () => (
  <div className="grid grid-flex grid-item padding-vertical-m padding-left-m background-white border-top">
    <SavingAddressSearch className="five-sixths" />
    <div className="grid-item one-sixth align-right padding-horizontal-l padding-vertical-s">
      <BurgerMenu />
    </div>
  </div>
);

export default AddressSearchAndBurgerMenu;
